import React from 'react';
import { Button } from '@mui/material';
import { ArrowBack as BackIcon } from '@mui/icons-material';

const CancelFeeScheduleButton: React.FC = () => {
  const handleBack = () => {
    // Navigate back to the previous page
    window.history.back();
  };

  return (
    <Button
      variant="outlined"
      startIcon={<BackIcon />}
      onClick={handleBack}
      sx={{ minWidth: 120 }}
    >
      Back
    </Button>
  );
};

export default CancelFeeScheduleButton;
